var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8 14.5C12.3667 14.5 10.9696 14.1804 9.60867 13.5413C8.24778 12.9022 7.04222 12.0578 5.992 11.008C4.94178 9.95822 4.09733 8.75267 3.45867 7.39133C2.82 6.03 2.50044 4.63289 2.5 3.2C2.5 3 2.56667 2.83333 2.7 2.7C2.83333 2.56667 3 2.5 3.2 2.5H5.9C6.05556 2.5 6.19444 2.55 6.31667 2.65C6.43889 2.75 6.51111 2.87778 6.53333 3.03333L6.96667 5.36667C6.98889 5.52222 6.986 5.664 6.958 5.792C6.93 5.92 6.86622 6.03378 6.76667 6.13333L5.16667 7.76667C5.63333 8.56667 6.21667 9.31667 6.91667 10.0167C7.61667 10.7167 8.38889 11.3222 9.23333 11.8333L10.8 10.2667C10.9 10.1667 11.0307 10.0918 11.192 10.042C11.3533 9.99222 11.5116 9.97822 11.6667 10L13.9667 10.4667C14.1222 10.5 14.25 10.5751 14.35 10.692C14.45 10.8089 14.5 10.9449 14.5 11.1V13.8C14.5 14 14.4333 14.1667 14.3 14.3C14.1667 14.4333 14 14.5 13.8 14.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightPhone);
export default __webpack_public_path__ + "static/media/light-phone.c629bf1bb8c441cd2acecf27a2dff8b8.svg";
export { ForwardRef as ReactComponent };